var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrnature(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 162 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ea0a0;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-46-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "cls-1",
    d: "M103.42,29.22V17.68a4.07,4.07,0,0,1,.07-1.11.73.73,0,0,1,.82-.57.7.7,0,0,1,.64.57,5.06,5.06,0,0,1,0,.95V31.44c0,.57.18,1.21-.55,1.56-.67.06-1-.51-1.31-1-2.69-4-5.34-8-8-12a3.28,3.28,0,0,0-.46-.45V32.36c-.52.7-1,.76-1.53.25A2.82,2.82,0,0,1,93,31.38V17.46c0-.57-.12-1.24.61-1.43s.92.35,1.19.8c1,1.49,2.05,3,3.05,4.5q2.52,3.75,5,7.51c.16.16.28.35.58.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "cls-1",
    d: "M138.23,33c-.81-.75-.81-.75-1-2.18a6.55,6.55,0,0,1-3.39,2.08,4.82,4.82,0,0,1-4.7-2A7.82,7.82,0,0,1,128,26.71V21.66a5.25,5.25,0,0,1,0-1,.82.82,0,0,1,.81-.66.73.73,0,0,1,.74.69c0,.49,0,1,0,1.46a37.67,37.67,0,0,0,.26,6c.29,1.37.9,2.51,2.29,2.83a3.62,3.62,0,0,0,4-1.1,4.75,4.75,0,0,0,1.23-3.1c0-1.73,0-3.49,0-5.21a5.61,5.61,0,0,1,0-.82.79.79,0,0,1,.87-.78c.51,0,.74.39.77.88V31.63c0,.59,0,1.11-.77,1.37",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "cls-1",
    d: "M124.09,20.27c1,.44,2.37-.32,2.91,1-.37,1.48-1.84.7-2.91,1.14v9.07c0,.56.13,1.2-.67,1.48-.84-.16-1-.73-1-1.52,0-2.46,0-5,0-7.42V22.54c-.54-.5-1.24-.06-1.77-.44-.27-.19-.57-.28-.61-.7s.24-.63.61-.82,1.1,0,1.77-.34V16.89c0-.57.3-.92.9-.89s.77.38.77.86v1.42c0,.69,0,1.36,0,2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "cls-1",
    d: "M73.91,33a1.34,1.34,0,0,1-.91-.54V22.15a1.94,1.94,0,0,1,.06-.6A.74.74,0,0,1,73.7,21a.7.7,0,0,1,.76.58c.12.36-.08.78.21,1.23a9.7,9.7,0,0,1,2.87-1.63A7.59,7.59,0,0,1,79,21c.56,0,1,.12,1,.79s-.41.78-.91.75a3.5,3.5,0,0,0-1.26.27,4.71,4.71,0,0,0-3.34,4.58c0,1.45,0,2.93,0,4.37,0,.52,0,1-.58,1.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "cls-1",
    d: "M143,32.56V22.19c0-.54,0-1,.68-1.15.5-.09.74.24.83,1.12,0,.18,0,.4.06.73,1.41-1,2.77-2,4.54-1.88a1.11,1.11,0,0,1,.89.7c-.09.57-.38.79-1,.88A4.68,4.68,0,0,0,145.19,25a4.36,4.36,0,0,0-.65,2.43v4.51c0,.4,0,.79-.45,1s-.74,0-1.09-.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    className: "cls-1",
    d: "M83,32.1a.83.83,0,0,1-.87.9A1.11,1.11,0,0,1,81,32a1,1,0,1,1,2,.14",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    className: "cls-1",
    d: "M67.62,27.61c-1.75,3.21-4.56,3.94-7.93,3.46l.09-13.35A7.15,7.15,0,0,1,67,20.4a7,7,0,0,1,.58,7.21m2.15-5a8.17,8.17,0,0,0-6.1-6.33A16.15,16.15,0,0,0,59.41,16c-1.29,0-1.41.12-1.41,1.41v6.78c0,2.42,0,4.82,0,7.21,0,1.2.31,1.51,1.41,1.54a16.05,16.05,0,0,0,2.3,0,8.45,8.45,0,0,0,5.85-2.61,8.19,8.19,0,0,0,2.18-7.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "cls-1",
    d: "M160.07,26.7h-9a4.66,4.66,0,0,1,8.06-2.62,2.83,2.83,0,0,1,1,2.62M155.49,21a6.29,6.29,0,0,0-6.4,5.47,6.5,6.5,0,0,0,8.22,7.32A5.06,5.06,0,0,0,160.17,32a.78.78,0,0,0,.06-1,.92.92,0,0,0-1-.33c-.39.1-.59.46-.88.68a4.09,4.09,0,0,1-4.22.68A4.45,4.45,0,0,1,151,28.12h11c.23-4.14-2.63-7.18-6.5-7.12",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "cls-1",
    d: "M112.45,32.31c-2.43,0-5-2.39-4.73-4.74.29-3,1.88-4.81,4.93-4.88a4.81,4.81,0,0,1-.2,9.62M119,27.15A6.42,6.42,0,0,0,112.88,21c-4.19-.29-8.11,4.2-6.52,8.62,1.46,4.07,6.71,5.68,9.76,3.17a9.92,9.92,0,0,1,1.07-.71c.06.13.12.19.16.29v.48a.77.77,0,0,0,.84.94c.49,0,.81-.39.81-1-.06-1.88,0-3.78,0-5.65",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    className: "cls-1",
    d: "M39.81,29.57a8,8,0,0,1-5,4c-.25.06-.5.16-.76.22s-.28.13-.47.22c-.19,1.69.19,3.41-.44,5.11-.94.31-1.35-.25-1.73-.82-1.76-2.57-3.51-5.14-5.31-7.71-3.2-4.66-6.44-9.3-9.64-14-.13-.19-.16-.5-.69-.56-.07,2.54,0,5.07,0,7.58V38.88c-1.32.37-1.54.25-1.6-.82V13.35a.77.77,0,0,1,.6-.82.92.92,0,0,1,1,.25c.29.38.57.75.82,1.13C19,17.45,21.43,21,23.88,24.56c.16.25.22.6.76.75a17.65,17.65,0,0,1,2.64-8.24,29.73,29.73,0,0,1,5.43-7A11,11,0,0,1,35.54,13a26.18,26.18,0,0,1,4.78,9.18c.66,2.51.81,5-.51,7.39M25.23,0A25,25,0,0,0,0,24.87,24.26,24.26,0,0,0,7,42.32a24.42,24.42,0,0,0,18,7.68,23.92,23.92,0,0,0,17.56-7.24C47.48,37.91,50,32,50,23.37,50.25,11.18,38.56.06,25.23,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    className: "cls-1",
    d: "M38.35,24.26c-1.56,1.47-3,3-4.66,4.37A1.86,1.86,0,0,0,33,30.18,4.6,4.6,0,0,0,33.39,32a6.6,6.6,0,0,0,5.47-8,.69.69,0,0,0-.51.26",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    className: "cls-1",
    d: "M28.65,26.11c-.76-.68-1.49-1.37-2.32-2.11-1.27,3.31,1.24,6.89,5.47,8,.38-2.66.38-2.66-1.46-4.37-.58-.49-1.12-1-1.69-1.52",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    className: "cls-1",
    d: "M33.1,27a.77.77,0,0,0,.73-.29c1.73-1.63,3.44-3.3,5.17-5A4.39,4.39,0,0,0,37.77,19c-1.3,1.29-2.51,2.52-3.74,3.71a5.1,5.1,0,0,1-.47.45,1.23,1.23,0,0,0-.56.91c0,1,0,1.93.1,2.93",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-27",
    className: "cls-1",
    d: "M33,12V22l4-4.13A27.83,27.83,0,0,0,33,12",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-29",
    className: "cls-1",
    d: "M31.8,24.66a1.07,1.07,0,0,0-.4-.95c-1.33-1.23-2.67-2.48-4-3.71a13.85,13.85,0,0,0-1.05,2.54C28,24.26,29.77,26,31.8,28c0-1.35,0-2.36,0-3.34",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-31",
    className: "cls-1",
    d: "M32,13a34.36,34.36,0,0,0-4,5.71A53.4,53.4,0,0,1,32,23Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-33",
    className: "cls-1",
    d: "M30,34a12.11,12.11,0,0,0,.94,2c.13-2,.13-2-.94-2",
    transform: "translate(0 0)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrnature);
export default __webpack_public_path__ + "static/media/drnature.3104ab9094ec9f7a8ffbe22110ceff86.svg";
export { ForwardRef as ReactComponent };